import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';
import AGB from './pages/AGB';
import Impressum from './pages/Impressum';
import Immobilien from './pages/services/Immobilien';
import Malerarbeiten from './pages/services/Malerarbeiten';
import Bodenbelaege from './pages/services/Bodenbelaege';
import FliesenNaturstein from './pages/services/FliesenNaturstein';
import Gipserarbeiten from './pages/services/Gipserarbeiten';
import Schalungsarbeiten from './pages/services/Schalungsarbeiten';
import Trockenbau from './pages/services/Trockenbau';
import Fassaden from './pages/services/Fassaden';
import TuerenFenster from './pages/services/TuerenFenster';
import SchimmelRiss from './pages/services/SchimmelRiss';
import PflasterDach from './pages/services/PflasterDach';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen/immobilien" element={<Immobilien />} />
          <Route path="/leistungen/malerarbeiten" element={<Malerarbeiten />} />
          <Route path="/leistungen/bodenbelaege" element={<Bodenbelaege />} />
          <Route path="/leistungen/fliesen-naturstein" element={<FliesenNaturstein />} />
          <Route path="/leistungen/gipserarbeiten" element={<Gipserarbeiten />} />
          <Route path="/leistungen/schalungsarbeiten" element={<Schalungsarbeiten />} />
          <Route path="/leistungen/trockenbau" element={<Trockenbau />} />
          <Route path="/leistungen/fassaden" element={<Fassaden />} />
          <Route path="/leistungen/tueren-fenster" element={<TuerenFenster />} />
          <Route path="/leistungen/schimmel-riss" element={<SchimmelRiss />} />
          <Route path="/leistungen/pflaster-dach" element={<PflasterDach />} />
          <Route path="/uber-uns" element={<AboutUs />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
        <Footer />
        <FloatingButtons />
      </div>
    </BrowserRouter>
  );
}

export default App;